import { dramaMeta, heroStats } from '@/mocks/drama';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[660px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20family%20living%20room%20at%20golden%20hour%2C%20soft%20dramatic%20side%20lighting%20through%20gauze%20curtains%2C%20elegant%20modern%20Chinese%20home%20interior%20with%20wooden%20furniture%20and%20warm%20amber%20lamp%20glow%2C%20moody%20editorial%20film%20still%20aesthetic%2C%20rich%20crimson%20and%20gold%20accents%2C%20shallow%20depth%20of%20field%2C%20premium%20short%20drama%20poster%20atmosphere&width=1600&height=900&seq=drama-hero-main&orientation=landscape"
        alt="《漂亮的小姨子》短剧主视觉：温暖的家中客厅场景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/60 to-foreground-950/80" />

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 pt-32 pb-14 md:pt-40 md:pb-20 max-w-7xl">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-foreground-950/40 px-3 py-1 font-label text-xs text-accent-300">
            <i className="ri-fire-line" aria-hidden="true" />
            {dramaMeta.updatedTo} · {dramaMeta.updateNote}
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight">
            漂亮的小姨子
          </h1>
          <p className="mt-4 font-heading text-lg md:text-2xl text-accent-200">
            {dramaMeta.tagline}
          </p>
          <p className="mt-5 font-body text-sm md:text-base leading-relaxed text-background-200 max-w-2xl">
            {dramaMeta.summary}
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {dramaMeta.tags.map((tag) => (
              <span key={tag} className="rounded-full bg-background-50/10 border border-background-50/25 px-3 py-1 font-label text-xs text-background-100">
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#episodes"
              className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-list-check-2 text-lg" aria-hidden="true" />
              全集分集导览
            </a>
            <a
              href="#plot"
              className="flex items-center justify-center gap-2 rounded-md border border-background-50/40 bg-foreground-950/30 px-6 py-3 font-label text-sm font-medium text-background-50 hover:bg-foreground-950/60 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line text-lg" aria-hidden="true" />
              剧情篇章与大结局
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {heroStats.map((stat) => (
            <div key={stat.id} className="rounded-lg border border-background-50/20 bg-foreground-950/45 p-4 backdrop-blur-sm">
              <p className="font-heading text-xl md:text-2xl font-bold text-background-50">{stat.value}</p>
              <p className="mt-1 font-label text-xs text-accent-300">{stat.label}</p>
              <p className="mt-1 font-body text-xs text-background-300">{stat.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}